export const LOGIN_URL = "https://mikeapi-staging.mikelegal.com/api";
export const ROOT_URL = `${LOGIN_URL}/iris`;

// export const LOGIN_URL = "http://127.0.0.1:8000/api";
// export const ROOT_URL = "http://127.0.0.1:8000/api/iris";
